/* eslint-disable react/style-prop-object */

import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const RoadIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <path
        d="M0.534517 13.7621H6.41553L6.67201 10.4115H9.32174L9.57821 13.7621H15.4592C15.5478 13.7618 15.635 13.7398 15.7132 13.6981C15.7913 13.6563 15.8581 13.5961 15.9075 13.5226C15.957 13.4491 15.9877 13.3646 15.997 13.2765C16.0063 13.1884 15.9938 13.0993 15.9607 13.0171L11.7346 2.56198C11.6631 2.3944 11.5438 2.25166 11.3915 2.15168C11.2392 2.0517 11.0607 1.99894 10.8786 2.00002H8.67482L8.83819 4.23317H7.14739L7.31075 2.00002H5.11518C4.93114 2.00028 4.75137 2.05545 4.59887 2.15847C4.44638 2.26149 4.32809 2.40768 4.25916 2.57832L0.0329969 13.0335C0.00325229 13.1148 -0.006585 13.2021 0.00430786 13.288C0.0152007 13.3739 0.046507 13.4559 0.0956082 13.5273C0.144709 13.5986 0.210178 13.6571 0.286537 13.698C0.362897 13.7388 0.447928 13.7608 0.534517 13.7621ZM7.04284 5.57764H8.9509L9.19431 8.74848H6.79943L7.04284 5.57764Z"
        fill="white"
      />
    </SvgIcon>
  );
});
